import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.scss";

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToAbout = useCallback(() => {
    navigate("/about");
  }, [navigate]);

  return (
    <footer className="footer mt-auto py-3 bg-dark text-white">
      <div className="container" onClick={handleNavigateToAbout}>
        <span>© 2025 Pool Tonight - All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
